import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClockRotateLeft, faBuildingColumns, faHouse, faSquareRss } from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react';

interface IntroBoxProps {
    onResetClick: () => void;
    onCompareClick: () => void;
    boeInterestRate: String;
}

const IntroBox = ({ onResetClick, onCompareClick, boeInterestRate }: IntroBoxProps) => {
    const [compareTwo, setCompareTwo] = useState(false);
    const handleCompareClick = () => {
        if (onCompareClick) onCompareClick();
        setCompareTwo(!compareTwo);
    };

    return (
        <div className="bg-base-300 rounded-box p-3">
            <div className="flex justify-between items-center pb-4">
                <h1 className="text-2xl font-bold"><FontAwesomeIcon icon={faHouse} className="mr-2" />Mortgage Modeller</h1>
                <a href="https://www.bankofengland.co.uk/" className="text-xl font-semibold p-2 btn-primary rounded-full mt-4 md:mt-auto flex items-center justify-center">
                    <FontAwesomeIcon icon={faBuildingColumns} className="ml-2 mr-2" /><p className="text-xl font-medium">Bank of England Interest Rate: <span className="text-xl font-bold">3.75% <FontAwesomeIcon icon={faSquareRss} className=" mr-2" /></span></p>
                </a>
            </div>
            <div className="flex flex-col md:flex-row justify-between items-stretch">
                <div className="w-full md:w-1/2 space-y-2">
                    <p className="font-medium">This models the simulation of an entire term of a mortgage loan. It can provide estimates or you can fine-tune it to provide far more accurate results using the various inputs available. You can hover over the chart for more data.</p>
                </div>
                <div className="w-full md:w-1/2 flex justify-end md:justify-end items-end space-x-4">
                    <button className="text-xl font-semibold p-2 btn-accent rounded-full mt-4 md:mt-auto flex items-center justify-center" onClick={handleCompareClick}>
                        {!compareTwo ? "Compare Two Mortgages" : "Back To Single Mortgage"}
                    </button>
                    <button className="text-xl font-semibold p-2 btn-accent rounded-full mt-4 md:mt-auto flex items-center justify-center" onClick={onResetClick}>
                        Clear <FontAwesomeIcon icon={faClockRotateLeft} className="ml-2" />
                    </button>
                </div>
            </div>
        </div>
    );
}

export default IntroBox;
